import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Lenis is dynamically imported so its ~20 kB (uncompressed) doesn't ship in the
// initial main bundle. It initialises after first paint, which is fine for a
// nice-to-have smooth-scroll effect and keeps LCP untouched.
export default function SmoothScroll({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    let rafId;
    let lenisInstance;

    import(/* webpackChunkName: "lenis" */ "lenis").then(({ default: Lenis }) => {
      if (cancelled) return;
      lenisInstance = new Lenis({
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      const raf = (time) => {
        lenisInstance.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    });

    return () => {
      cancelled = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (lenisInstance) lenisInstance.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
}
